import React from "react";

interface GroupContextValue {
  groupControlsFocus: boolean;
  enterGroup: () => void;
}

export const GroupedNavigationContext = React.createContext<GroupContextValue>({
  groupControlsFocus: false,
  enterGroup: () => {},
});

export const GroupedNavigationProvider: React.FC<
  React.PropsWithChildren<{
    groupControlsFocus: boolean;
    onGroupEnter?: () => void;
  }>
> = ({ children, groupControlsFocus, onGroupEnter }) => (
  <GroupedNavigationContext.Provider
    value={{ enterGroup: () => onGroupEnter?.(), groupControlsFocus }}
  >
    {children}
  </GroupedNavigationContext.Provider>
);
